import {
  FlexContainer,
  Label,
  LabelBase,
  Status,
  StatusType,
  useTimezone,
} from '@facephi/ui-react';
import Skeleton from 'react-loading-skeleton';
import { TrackingFamily } from '../../state/model';
import { DEFAULT_LOCALE, translate } from '../../utils/translations';
import { DetailHeaderStyles } from './Styles';

type Props = {
  date?: string;
  id?: string;
  currentStep?: string;
  status?: StatusType;
  loading?: boolean;
  family?: TrackingFamily;
  step?: string;
  locale?: string;
};
export const DetailHeader = ({
  date,
  id,
  currentStep,
  status,
  loading,
  family,
  step,
  locale = DEFAULT_LOCALE,
}: Props) => {
  const { formatTimezone } = useTimezone();

  return (
    <DetailHeaderStyles
      alignItems="center"
      justifyContent="space-between"
      columnGap="4.2"
    >
      {loading ? (
        <>
          <Skeleton height={18} width={130} borderRadius={8} />
          <Skeleton height={18} width={130} borderRadius={8} />
          <Skeleton height={18} width={130} borderRadius={8} />
        </>
      ) : (
        <>
          {date && (
            <Label fontSize="10">
              <strong>{translate('Date', locale)}: </strong>
              {formatTimezone(date)}
            </Label>
          )}
          <Label fontSize="10">
            <strong>{translate('ID:')}</strong> {id}
          </Label>
          <Label fontSize="10">
            <strong>{translate('Current Step', locale)}: </strong>{' '}
            {currentStep
              ? translate(currentStep.replaceAll('_', ' '), locale)
              : ''}
          </Label>
          {step && (
            <Label fontSize="10">
              <strong>{translate('Step', locale)}: </strong> {step}
            </Label>
          )}
        </>
      )}
      {loading ? (
        <Skeleton height={18} width={100} borderRadius={8} />
      ) : (
        <FlexContainer alignItems="center" columnGap="0.8">
          {family === TrackingFamily.AUTHENTICATION && (
            <LabelBase
              color="primary"
              label={translate('Authentication', locale)}
            />
          )}
          {status && <Status status={status} hasLabel locale={locale} />}
        </FlexContainer>
      )}
    </DetailHeaderStyles>
  );
};
